import React from 'react'
import styled from 'styled-components'

import { FirmwareListItem } from '../firmware-list-item'
import Text from '../../ui/Text'
import BootstrapModalLayout from '../../ui/BootstrapModalLayout'
import { FirmwareModalTable } from '../../ui/firmware/firmwareList'
import { Table } from '../table'
import { FirmwareGeneralModel } from '../../common/redux/api/web-api'
import useText from '../../common/hooks/useText'

const SText = styled.div`
    font-weight: 500;
`

export type ActivateFirmwareModalProps = {
    onCancel: () => void
    onConfirm: () => void
    currentFactoryFirmware?: FirmwareGeneralModel
    newFactoryFirmware: FirmwareGeneralModel
}

export function ActivateFirmwareModal({
    onCancel,
    onConfirm,
    currentFactoryFirmware,
    newFactoryFirmware,
}: ActivateFirmwareModalProps): React.ReactElement {
    const text = useText()
    return (
        <BootstrapModalLayout
            title={text('msgFWActivateModal')}
            size="lg"
            data-testid="activate-firmware-modal"
            actions={[
                {
                    label: text('btnCancel'),
                    btn: 'btn-secondary',
                    callback: onCancel,
                },
                {
                    label: text('btnConfirm'),
                    callback: onConfirm,
                },
            ]}
        >
            <SText data-testid="info">
                <Text code="msgFWInfo" />
            </SText>
            <SText>
                <Text code="msgFWCurrent" />
            </SText>
            {currentFactoryFirmware && (
                <Table>
                    <FirmwareModalTable />
                    <FirmwareListItem data={currentFactoryFirmware} />
                </Table>
            )}

            <SText>
                <Text code="msgFWNew" />
            </SText>
            <Table>
                <FirmwareModalTable />

                <FirmwareListItem data={newFactoryFirmware} />
            </Table>
        </BootstrapModalLayout>
    )
}
